import { render, staticRenderFns } from "./official.vue?vue&type=template&id=6d748316&scoped=true"
import script from "./official.vue?vue&type=script&lang=js"
export * from "./official.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d748316",
  null
  
)

export default component.exports